import React from 'react'

export const IcoShrink = ({...props}) => {
  const style = props.style?props.style:{}
  return (
    <svg className='icon-shrink' viewBox="0 0 15 16" {...props} style={{...style,fill:'none'}}>
      <path d="M5.13636 5.63636V2.09091M5.13636 5.63636H1.59091M5.13636 5.63636L1 1.5M5.13636 10.3636V13.9091M5.13636 10.3636H1.59091M5.13636 10.3636L1 14.5M9.86364 5.63636H13.4091M9.86364 5.63636V2.09091M9.86364 5.63636L14 1.5M9.86364 10.3636H13.4091M9.86364 10.3636V13.9091M9.86364 10.3636L14 14.5" stroke='currentColor' strokeWidth="1.5"/>
    </svg>
  )
}